function showForm(id) {
  document.getElementById(id).style.display = 'block';
}

function hideForm(id) {
  document.getElementById(id).style.display = 'none';
}

function goToOrder(orderUuid) {
  return window.location.href = `/order/${orderUuid}`;
}

/// /STRIPE APPLE PAY
if (document.getElementById('guaranteed-payment-request-button')) {
  // variables
  const container = document.getElementById('requestContainer');

  const publicKey = container.dataset.stripePublicKey;

  // the club
  const { clubName } = container.dataset;

  // the order
  const amount = parseInt(container.dataset.orderAmount);
  const orderName = `Order for ${clubName}`;
  const { countryCode } = container.dataset;
  const currency = container.dataset.countryCurrencyCode.toLowerCase();

  const containsSubsciptionBooking = (container.dataset.hasSubscriptionBookings
 == '1');

  const stripe = Stripe(publicKey, {});

  function makePaymentRequest(ev) {
    // Send the token to your server to charge it!
    const route = Routing.generate('api_v4_pay_basket');
    console.log(ev.token);
    return fetch(route, {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        stripeToken: ev.token.id,
        rememberCard: containsSubsciptionBooking ? '1' : '0',
      }),
    });
  }

  function getItemsToDisplay() {
    return [];
  }

  const payUsingStripe = document.getElementById('payUsingStripe');

  payUsingStripe.addEventListener(
    'click',
    () => {
      // hideForm('payment-request-button');
      hideForm('payUsingStripe');
      showForm('old-card-form');
    },
    false,
  );

  const paymentRequest = stripe.paymentRequest({
    country: countryCode,
    currency,
    requestPayerName: true,
    total: {
      label: orderName,
      amount,
    },
    displayItems: getItemsToDisplay(),
  });

  const elements = stripe.elements();
  const prButton = elements.create('paymentRequestButton', {
    paymentRequest,
  });

  // Check the availability of the Payment Request API first.
  paymentRequest.canMakePayment().then((result) => {
    console.log(result, `amount: ${amount}`);
    if (result && (amount > 0 || containsSubsciptionBooking)) {
      if (!result.applePay) {
        showForm('non-apple-pay-helper');
      }
      prButton.mount('#guaranteed-payment-request-button');
    } else {
      hideForm('guaranteed-payment-request-button');
      showForm('old-card-form');
    }
  });

  paymentRequest.on('token', (ev) => {
    makePaymentRequest(ev)
      .then(async (response) => {
        if (response.ok) {
          // Report to the browser that the payment was successful, prompting
          // it to close the browser payment interface.
          const json = await response.json();
          console.log(json);

          goToOrder(json.orderUUID);
          ev.complete('success');
        } else {
          // Report to the browser that the payment failed, prompting it to
          // re-show the payment interface, or show an error message and close
          // the payment interface.

          if (response.status == 401) {
            // using reload here instead of setting the location.href to '/login'
            // because it will preserve the redirect
            ev.complete('fail');
            location.reload();
          }

          document.getElementById(
            'payment-request-failed',
          ).style.display = 'block';

          hideForm('guaranteed-payment-request-button');
          showForm('old-card-form');
          ev.complete('fail');
        }
      })
      .catch((response) => {
        showForm('old-card-form');
      });
  });
}

if (document.getElementById('guaranteed-payment-form')) {
  // elements
  const container = document.getElementById('requestContainer');
  const publicKey = container.dataset.stripePublicKey;

  const stripe = Stripe(publicKey);
  const elements = stripe.elements();
  const style = {
    base: {
      color: '#32325d',
      lineHeight: '18px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  };

  // Create an instance of the card Element.
  const card = elements.create('card', { style, hidePostalCode: true });

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount('#card-element');

  card.on('focus', (event) => {
    document.querySelector('#new-card-radio').checked = true;
  });

  card.addEventListener('change', ({ error }) => {
    const displayError = document.getElementById('card-errors');
    if (error) {
      displayError.textContent = error.message;
    } else {
      displayError.textContent = '';
    }
  });

  // Create a token or display an error when the form is submitted.
  const form = document.getElementById('guaranteed-payment-form');
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    var buttons = document.querySelectorAll('button[type="submit"]');

    for (let index = 0; index < buttons.length; index++) {
      const button = buttons[index];
      button.setAttribute('disabled', 'disabled');
    }

    hideForm('make-payment-button');
    hideForm('guaranteed-payment-request-button');

    showForm('loading-button');

    const radioButton = document.querySelector('input[name="payment-source"]:checked')
            || document.querySelector('input[name="payment-source"]');

    const rememberCard = document.querySelector(
      'input[name="rememberCard"]',
    );

    if (rememberCard) {
      var rememberCardValue = rememberCard.checked ? 1 : 0;
    } else {
      var rememberCardValue = 0;
    }

    const subscriptionCard = document.querySelector(
      'input[name="subscriptionCard"]',
    );

    if (subscriptionCard) {
      var rememberCardValue = 1;
    }

    // if it's a new card then try to submit it
    if (radioButton.value == 'new-card') {
      const name = document.querySelector('#name-input').value;
      const { token, error } = await stripe.createToken(card, { name });
      const errorElement = document.getElementById('card-errors');
      if (error) {
        var buttons = document.querySelectorAll(
          'button[type="submit"]',
        );

        for (let index = 0; index < buttons.length; index++) {
          const button = buttons[index];
          button.disabled = false;
        }

        // Inform the customer that there was an error.
        errorElement.style.display = 'block';
        errorElement.textContent = error.message;

        showForm('make-payment-button');
        showForm('guaranteed-payment-request-button');
        hideForm('loading-button');
      } else {
        errorElement.style.display = 'none';
        errorElement.textContent = '';

        // Send the token to your server.
        makePaymentRequest(token, rememberCardValue);
      }
      // otherwise it's a saved card to try to use it
    } else {
      makePaymentRequest({ savedCard: radioButton.value });
    }
  });

  async function makePaymentRequest(token, saveCardForFuture) {
    // Send the token to your server to charge it!
    const route = Routing.generate('api_v4_pay_basket');

    if (token.id) {
      var body = {
        stripeToken: token.id,
        rememberCard: saveCardForFuture,
        // uniqueIdempotencyKey: container.dataset.orderUuid
      };
    } else {
      var body = {
        savedCard: token.savedCard,
      };
    }

    try {
      const response = await fetch(route, {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });

      if (response.status == 401) {
        // using reload here instead of setting the location.href to '/login'
        // because it will preserve the redirect
        location.reload();
      }

      const json = await response.json();

      goToOrder(json.orderUUID);
    } catch (error) {
      const buttons = document.querySelectorAll('button[type="submit"]');

      for (let index = 0; index < buttons.length; index++) {
        const button = buttons[index];
        button.disabled = false;
      }

      showForm('make-payment-button');
      showForm('guaranteed-payment-request-button');
      hideForm('loading-button');

      console.error(error);
    }
  }

  // styling of accordion
  if (window.innerWidth > 648) {
    document.getElementById('order').classList.add('active');
  }
}
